import { useCallback, useState } from 'react';

interface UseConfirmationInput<TScope> {
  onConfirm(scope: TScope): void;
}

interface UseConfirmationHook<TScope> {
  handle(scope: TScope): void;
  confirm(): void;
  abort(): void;
  scope: TScope | null;
}

export function useConfirmation<TScope>({
  onConfirm,
}: UseConfirmationInput<TScope>): UseConfirmationHook<TScope> {
  const [scope, setScope] = useState<TScope | null>(null);
  const handle = useCallback(
    (handledScope) => {
      setScope(handledScope);
    },
    [setScope],
  );
  const confirm = useCallback(() => {
    if (scope !== null) {
      setScope(null);
      onConfirm(scope);
    }
  }, [scope, setScope, onConfirm]);
  const abort = useCallback(() => {
    setScope(null);
  }, [setScope]);

  return { handle, confirm, abort, scope };
}
